import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}
export function fDateForBackend(date) {
  return date ? format(new Date(date), 'yyyy-MM-dd') : '';
}

export function fDaysLeft(date) {
  if (!date) return '';

  const now = new Date();
  const target = new Date(date);

  // Get difference in full days (rounded down)
  const diffInMs = target.getTime() - now.getTime();
  const daysLeft = Math.max(Math.floor(diffInMs / (1000 * 60 * 60 * 24)), 0);

  if (daysLeft === 0) return '';

  return `${daysLeft} day${daysLeft !== 1 ? 's' : ''} left`;
}